// DLD-422: single source of truth for the disclosure rendered next to the SMS
// consent checkbox. The visible text MUST match SOTSVC_SMS_CONSENT_TEXT — that
// constant is what gets stored in `leads.consent_text` and would be presented
// in a TCPA defense, so what the user saw and what we recorded need to match.

export function SmsConsentDisclosure() {
  return (
    <span className="text-xs text-white/70 leading-relaxed">
      I agree to receive text messages from Sonz of Thunder Services at the phone number provided,
      including appointment confirmations, service quotes, missed-call follow-ups, and post-service
      review requests. Message frequency varies. Message and data rates may apply. Reply STOP to opt
      out, HELP for help. See Privacy Policy at{' '}
      <a
        href="/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="text-thunder underline hover:text-thunder-light"
      >
        https://sotsvc.com/privacy
      </a>{' '}
      and Terms of Service at{' '}
      <a
        href="/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="text-thunder underline hover:text-thunder-light"
      >
        https://sotsvc.com/terms
      </a>
      .
    </span>
  );
}
